<template>
  <div class="background-slider">
    <el-slider v-model="bgAlpha"
               :show-tooltip="false"
               style="padding: 0 10px;"
               :min="0"
               :max="1"
               :step="0.01"
               @input="backgroundAlphaChanged" />
  </div>
</template>

<script>
import bus, { EVENTS } from '@/modules/report-inspector/report-inspector-scene/bus';

export default {
  name: 'BackgroundAlphaSlider',
  data() {
    return {
      bgAlpha: 0.75
    };
  },
  watch: {
    bgAlpha(alpha) {
      this.$emit('input', alpha);
    }
  },
  methods: {
    backgroundAlphaChanged() {
      bus.$emit(EVENTS.BACKGROUND_ALPHA_CHANGED, this.bgAlpha);
    }
  }
};
</script>

<style lang="scss">
.background-slider {
  width: 200px;

  .el-slider {
    &__runway {
      background: linear-gradient(90deg, #fff 0%, #404040 100%);
      border: 0.2px solid #000;

      .el-slider__bar {
        background-color: transparent;
      }

      .el-slider__button-wrapper {
        .el-slider__button {
          background: rgba(255, 255, 255, 0.5);
          border: 1px solid #6a6a6a;
        }
      }
    }
  }
}
</style>
